export default __webpack_public_path__ + "static/media/lumen-formula-stepper-2.5139cf0c.svg";